import { localStorageItemKeys } from '~constants/local-storage-items'
import { Option } from '~pages/pages-behind-login/profile-page/profile-page'
import { getTokenSilently } from '~utils/auth'
import { ApiConfig } from './config'

export const defaultFetcher = async (
  url: string,
  args: any,
): Promise<unknown> => {
  try {
    const token: string = await getTokenSilently()

    const handleUnauthorized = async () => {
      // We don't have access to the router hooks here, so we need to manually use `browserHistory`.
      // Changing window.location.href would cause an infinite redirect
      // browserHistory.push(PageRoute.UNAUTHORIZED)
      return
    }

    if (!token) {
      return handleUnauthorized()
    } else {
      const impersonate: Option | undefined = localStorage.getItem(
        localStorageItemKeys.impersonate,
      )
        ? JSON.parse(
            localStorage.getItem(localStorageItemKeys.impersonate) as string,
          )
        : undefined
      const headers: HeadersInit = {
        Authorization: `Bearer ${token}`,
      }

      if (impersonate?.id) {
        headers['x-impersonate'] = impersonate.id
      }
      const res = await fetch(ApiConfig.domain + url, {
        headers,
        ...args,
      })

      return res.json().then(function (response) {
        if (res.status === 401 || res.status === 403) {
          handleUnauthorized()
        }
        if (response.error || !res.ok) {
          throw new Error(response.statusCode)
        }
        return response
      })
    }
  } catch (err) {
    throw new Error(url)
  }
}
